import { inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { NavigateService } from '../services/navigate.service.js';
import { AuthService } from './auth.service.js';

export const authGuard: () => boolean | UrlTree = () => {
	const authService = inject(AuthService);
	const navigateService = inject(NavigateService);

	if (authService.isAuthenticated()) {
		return true;
	}

	return navigateService.router.createUrlTree([navigateService.loginPage().getUrl()]);
};
